/**
 * 決済番号と会員IDを連結してフォーマットする
 * @param {string} linkageIdentifier - 決済番号
 * @param {string|null} memberId - 会員ID（オプション）
 * @returns {string} フォーマットされた決済番号（会員IDが存在する場合は連結）
 */
export const formatLinkageIdentifier = (linkageIdentifier, memberId = null) => {
  if (!linkageIdentifier) return '';
  
  if (memberId) {
    return `${linkageIdentifier}@@@${memberId}`;
  }
  
  return linkageIdentifier;
};

